module.exports = __webpack_public_path__ + "static/img/jiaoyu.de623e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/jiaoyu.png
// module id = tw8Y
// module chunks = 4